import { apis2 } from '.';
import http from './http';

export default class OpenWorkTimeApi {
  static findByOwner (param: {
    engineerId: number,
  }) {
    return http.post(apis2.OpenWorkTimeApi.findByOwner, param)
  }
  
  static saveOrUpdate (param: {
    workTime: {
      detailsJson: string,
      engineerId: number,
      id: number,
      status: boolean
    }
  }) {
    return http.post(apis2.OpenWorkTimeApi.saveOrUpdate, param)
  }
}
